import _ from "lodash";

export const getColumn = ({
  field,
  headerName = _.startCase(field),
  minWidth = 140,
  type = "string",
  headerAlign = "left",
  align = "left",
  ...additionalValues
}) => ({
  field,
  headerName,
  type,
  flex: 1,
  minWidth,
  align,
  headerAlign,
  ...additionalValues,
});
